import {StylizedMenuList} from './StylizedMenuList';
import { withErrorBoundary } from '../../SystemComponent/ErrorBoundary';

export default withErrorBoundary('StylizedMenuList')(StylizedMenuList);
